import React from 'react';
import ContentManagement from './ContentManagement';

const AboutContent = () => {
  return <ContentManagement page="about" />;
};

export default AboutContent;
